import { FETCH_PROPERTIES_STARTED, FETCH_PROPERTIES_SUCCEEDED, FETCH_PROPERTY_GROUPS_STARTED, FETCH_PROPERTY_GROUPS_SUCCEEDED, FETCH_PROPERTY_GROUPS_FAILED } from '../actions/ActionTypes';
import { FAILED, STARTED, UNINITIALIZED, SUCCEEDED } from '../constants/RequestStatusTypes';
const initialState = {
  properties: {},
  propertiesStatus: UNINITIALIZED,
  propertyGroups: [],
  propertyGroupsStatus: UNINITIALIZED
};
export default function properties(state = initialState, action) {
  switch (action.type) {
    case FETCH_PROPERTIES_STARTED:
      return Object.assign({}, state, {
        propertiesStatus: STARTED
      });
    case FETCH_PROPERTIES_SUCCEEDED:
      {
        const {
          payload
        } = action;
        const propertiesAsMapById = payload.reduce((allProperties, {
          property
        }) => {
          allProperties[property.name] = property;
          return allProperties;
        }, {});
        return Object.assign({}, state, {
          properties: propertiesAsMapById,
          propertiesStatus: SUCCEEDED
        });
      }
    case FETCH_PROPERTY_GROUPS_STARTED:
      return Object.assign({}, state, {
        propertyGroupsStatus: STARTED
      });
    case FETCH_PROPERTY_GROUPS_SUCCEEDED:
      {
        const {
          payload
        } = action;
        if (!(payload !== null && payload !== void 0 && payload.results)) {
          return state;
        }
        return Object.assign({}, state, {
          propertyGroups: payload.results,
          propertyGroupsStatus: SUCCEEDED
        });
      }
    case FETCH_PROPERTY_GROUPS_FAILED:
      {
        return Object.assign({}, state, {
          propertyGroupsStatus: FAILED
        });
      }
    default:
      return state;
  }
}